export interface Item {
  id: number;
  type: string;
  code: string;
  description: string;
}

export interface FormData {
  ItemsBasicInfo: any;
  ItemsAttribute: any;
}

export interface ItemsBasicInfoData {
  client: "";
  code: string;
  name: string;
  description: string;
  hts_code: string;
  item_category: any;
  item_group: any;
  unit_cost: string;
  average_unit_cost: string;
  unit_price: string;
  logo: any;
}

export const ItemsBasicInfoData: ItemsBasicInfoData = {
  client: "",
  code: "",
  name: "",
  description: "",
  hts_code: "",
  item_category: "",
  item_group: "",
  unit_cost: "",
  average_unit_cost:"",
  unit_price: "",
  logo: null
};

export interface ItemsAttributeData {
  serial_tracking: any;
  fifo_method: any;
  fifo_date_method: any;
  min_stock_level: string;
  max_stock_level: string;
  suggested_stock_level: string;
  popularity: any;
  shelf_life: string;
  ship_life: string;
  country_of_origin: any;
  is_tag_tracking: boolean;
  is_lot_tracking: boolean;
  is_expiry_tracking: boolean;
}

export const ItemsAttributeData: ItemsAttributeData = {
  serial_tracking: "",
  fifo_method: "",
  fifo_date_method: "",
  min_stock_level: "",
  max_stock_level: "",
  suggested_stock_level: "",
  popularity: "",
  shelf_life: "",
  ship_life: "",
  is_tag_tracking: false,
  is_lot_tracking: false,
  is_expiry_tracking: false,
  country_of_origin: "",
};

export const mapDataToTabs = (data: any): FormData => {
  if (!data) {
    return {
      ItemsBasicInfo: {},
      ItemsAttribute: {}
    };
  }

  const basicInfoData = {
    client: data.client,
    code: data.code,
    name: data.name,
    description: data.description,
    hts_code: data.hts_code,
    item_category: data.item_category,
    item_group: data.item_group,
    unit_cost: data.unit_cost,
    average_unit_cost: data.average_unit_cost,
    unit_price: data.unit_price,
    logo: data.logo,
  };

  const attributeData = {
    serial_tracking: data.serial_tracking,
    fifo_method: data.fifo_method,
    fifo_date_method: data.fifo_date_method,
    min_stock_level: data.min_stock_level,
    max_stock_level: data.max_stock_level,
    suggested_stock_level: data.suggested_stock_level,
    popularity: data.popularity,
    shelf_life: data.shelf_life,
    ship_life: data.ship_life,
    is_tag_tracking: data.is_tag_tracking,
    is_lot_tracking: data.is_lot_tracking,
    is_expiry_tracking: data.is_expiry_tracking,
    country_of_origin: data.country_of_origin,
  };

  return {
    ItemsBasicInfo: basicInfoData,
    ItemsAttribute: attributeData
  };
};
interface Client {
  id: number;
  code: string;
  name: string;
  is_active: boolean;
}

interface SerialTracking {
  id: number;
  type: string;
  code: string;
  description: string;
}

interface FIFOMethod {
  id: number;
  type: string;
  code: string;
  description: string;
}

interface FIFODateMethod {
  id: number;
  type: string;
  code: string;
  description: string;
}

interface Popularity {
  id: number;
  type: string;
  code: string;
  description: string;
}

interface UOM {
  id: number;
  item: {
      id: number;
  };
  code: string;
  iso_code: string | null;
  name: string;
  description: string;
  numerator: number;
  denominator: number;
  precision: number;
  gtin: string | null;
  length: number | null;
  width: number | null;
  height: number | null;
  dimension_uom: string | null;
  weight: number | null;
  weight_uom: string | null;
}

export interface ItemDetails {
  id: number;
  created_by: number;
  created_at: string;
  updated_by: number;
  updated_at: string;
  client: Client;
  code: string;
  name: string;
  description: string;
  hs_code: string | null;
  hts_code: string;
  min_stock_level: string;
  max_stock_level: string;
  suggested_stock_level: string;
  shelf_life: string;
  ship_life: string;
  unit_cost: string;
  average_unit_cost: string;
  unit_price: string;
  suggested_retail_price: string | null;
  is_tag_tracking: boolean;
  is_lot_tracking: boolean;
  is_expiry_tracking: boolean;
  serial_tracking: SerialTracking;
  fifo_method: FIFOMethod;
  fifo_date_method: FIFODateMethod;
  item_category: any | null;
  item_group: any | null;
  item_brand: any | null;
  popularity: Popularity;
  base_uom: UOM;
  default_purchase_uom: UOM;
  default_sale_uom: UOM;
  is_active: boolean;
  user_defined_1: string | null;
  user_defined_2: string | null;
  user_defined_3: string | null;
  user_defined_4: string | null;
  user_defined_5: string | null;
  user_defined_6: string | null;
  user_defined_7: string | null;
  user_defined_8: string | null;
  logo: object | any;
  attachments: any[];
}
export class attachments {
  public original_name: string;
  public description: string;
  public content: string;
  constructor() {
      this.original_name = "";
      this.content = "";
      this.description = "";
  }
}
